import { FileManagerStates } from '../../../../../components/fileManager/types/fileManagerStates';
import { FileManagerVariants } from '../../../../../components/fileManager/types/fileManagerVariants';
import { commonStateToken } from './commonStateTokens';
export const getFileManagerStyles = (FOUNDATIONS, FONT) => ({
    [FileManagerVariants.DEFAULT]: {
        [FileManagerStates.DEFAULT]: {
            ...commonStateToken(FOUNDATIONS, {}),
        },
        [FileManagerStates.PROGRESS]: {
            ...commonStateToken(FOUNDATIONS, {}),
        },
        [FileManagerStates.COMPLETE]: {
            ...commonStateToken(FOUNDATIONS, {}),
        },
        [FileManagerStates.ERROR]: {
            ...commonStateToken(FOUNDATIONS, {
                loaderPasive: {
                    stroke: FOUNDATIONS.color_feedback_error_border_50,
                },
            }),
        },
    },
});
//# sourceMappingURL=styles.js.map